import React from 'react';
import { Table, Icon, Button, message, Popconfirm, Menu, Dropdown, Switch, Modal } from 'antd';
import { translate } from 'react-i18next';
import moment from 'moment';
import { compose } from 'redux';
import ModalSchools from '../../components/ModalSchools'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { pathOr } from 'ramda'
import axios from 'axios';
import { fbFunctionsURL } from '../../config.js'
import { asiapacific, americas, europe, middleeast } from '../../components/ModalSchools/countries.js'

class STAdminSchools extends React.Component {

  constructor() {
    super();
    this.state = {
      modalOpen: false,
      modalData: null,
      toRemove: null,
      schoolType: 'All',
      schoolRegion: 'All',
      schoolCountry: 'All',
      loadingSwitch: false
    }
  }

  removeEntry = (mode) => {
    //Remove school data
    if (this.state.toRemove) {
      this.props.firebase.database().ref('schools/' + this.state.toRemove).update({
        address: '',
        name: '',
        active: false,
        description: '',
        email: '',
        phone: ''
      });

      //Remove students related to that school
      let users = Object.entries(this.props.users)

      let students = users.filter(student =>
        Object.values(student[1].roles)[0][0] == 'student' &&
        Object.keys(student[1].roles)[0] == this.state.toRemove
      )

      students.map(student => {
        this.props.firebase.database().ref('users/' + student[0]).update({
          active: false
        })
        this.props.firebase.database().ref('users/' + student[0] + '/profile').update({
          email: '',
          name: '',
          last_name: ''
        })
      })

      //Remove teachers related to this school
      let teachers = users.filter(student =>
        Object.values(student[1].roles)[0][0] == 'teacher' && Object.keys(student[1].roles)[0] == this.state.toRemove
      )
      teachers.map(teacher => {
        this.props.firebase.database().ref('users/' + teacher[0]).update({
          active: false
        })
        this.props.firebase.database().ref('users/' + teacher[0] + '/profile').update({
          email: '',
          name: '',
          last_name: ''
        })
      })

      this.setState({ toRemove: null })
    }
  }


  saveHistory = (data, id) => {
    const currentProducts = data.savedProduct
    const commingProducts = data.products
    const currentHistory = data.history || []

    const newSubscribe = (currentProducts === undefined || !currentProducts) ? commingProducts : commingProducts.filter(x => currentProducts && !currentProducts.includes(x));
    const unsubscribe = currentProducts && currentProducts.filter(x => commingProducts && !commingProducts.includes(x));

    if (newSubscribe && newSubscribe.length > 0) {
      newSubscribe.forEach((element) => {
        currentHistory.push({ 'productName': element, 'type': 'subscribed', 'date': Date.now() })
      });
    }
    if (unsubscribe && unsubscribe.length > 0) {
      unsubscribe.forEach((element) => {
        currentHistory.push({ 'productName': element, 'type': 'unsubscribe', 'date': Date.now() })
      });
    }
    this.props.firebase.database().ref('schools/' + id).update({
      history: currentHistory
    })
  }

  saveModal = (data, mode) => {

    if (!data.products || data.products.length == 0) {
      message.error('Please select a product')
      return
    }

    let id

    this.modal.cancel();
    if (mode == 'edit') {

      id = data.id
      this.props.firebase.database().ref('schools/' + id).update({
        //      group: data.group,
        type: data.type,
        program: data.program,
        name: data.name,
        region: data.region,
        country: data.country,
        description: data.description,
        address: data.address,
        phone: data.phone,
        email: data.email,
        products: data.products,
        id: data.id,
        academicYear: data.academicYear || 'August - July',
      }).then(() => {
        this.saveHistory(data, id)
      })
    } else {
      id = this.props.firebase.database().ref().child('schools').push().key
      this.props.firebase.database().ref('/schools/' + id).update({
        active: true,
        //      group: data.group,
        type: data.type,
        program: data.program,
        name: data.name,
        region: data.region,
        country: data.country,
        description: data.description,
        address: data.address,
        phone: data.phone,
        email: data.email,
        products: data.products,
        createdAt: Date.now(),
        id: data.id,
        trial: data.trial,
        academicYear: data.academicYear || 'August - July',
        skill_description: '<p><strong>Watch - </strong><em>I know what the use of the skill looks like when others are using it.&nbsp;I need lots of help to use the skill.</em></p><p><strong>Copy - </strong><em>I can copy someone else using the skill. I can use the skill in familiar situations with some help.</em></p><p><strong>Do - </strong><em>I am using the skill by myself in familiar situations. I don’t need help to use the skill anymore.</em></p><p><strong>Teach - </strong><em>I use the   skill without needing to think it through first. I can use the skill in unfamiliar situations without any help from anyone else.</em></p>'
      }).then(() => {
        this.saveHistory(data, id)
      })




    }

  }

  setSchoolState = (state, id) => {
    const _this = this
    this.setState({loadingSwitch: id})
    axios.post(`${fbFunctionsURL}/setSchoolState`, {
      schoolId: id,
      state: state
    })
    .then( () => {
      _this.props.firebase.database().ref(`/schools/${id}`).update({
        activated: state
      })
      .then( () => _this.setState({loadingSwitch: false}))
    })
    .catch( error => {
      _this.setState({loadingSwitch: false})
      Modal.error({
        title: 'An error happened :( ',
        content: error && error.message
      })
    })
  }

  cancelModal = () => {
    this.setState({ modalOpen: false, modalData: null })
  }

  openModal = (mode, data) => {
    this.setState({ modalOpen: true, modalData: data, modalMode: mode },
      () => {
        this.modal.updateData();
      })
  }

  schoolTypes = () => {
    return (
      <Menu onClick={(e) => this.setState({ schoolType: e.item.props.children })}>
        <Menu.Item key="0">All</Menu.Item>
        <Menu.Item key="1">Goverment / State</Menu.Item>
        <Menu.Item key="2">Private International</Menu.Item>
        <Menu.Item key="3">Private</Menu.Item>
      </Menu>
    )
  }

  schoolRegions = () => {
    return (
      <Menu onClick={(e) => this.setState({ schoolRegion: e.item.props.children })}>
        <Menu.Item key="0">All</Menu.Item>
        <Menu.Item key="1">Asia Pacific</Menu.Item>
        <Menu.Item key="2">Americas</Menu.Item>
        <Menu.Item key="3">Europe</Menu.Item>
        <Menu.Item key="4">Middle East</Menu.Item>
      </Menu>
    )
  }

  schoolCountries = () => {
    let countries;
    if (this.state.schoolRegion == 'Asia Pacific') {
      countries = asiapacific
    } else if (this.state.schoolRegion == 'Americas') {
      countries = americas
    } else if (this.state.schoolRegion == 'Europe') {
      countries = europe
    } else {
      countries = middleeast
    }

    return (
      <Menu onClick={(e) => this.setState({ schoolCountry: e.item.props.children })}>
        <Menu.Item key="all">All</Menu.Item>
        {countries.map((country, i) =>
          <Menu.Item key={i}>{country}</Menu.Item>
        )}
      </Menu>
    )
  }

  cancelExpiry = (schoolId) => {
    this.props.firebase.database().ref(`schools/${schoolId}`).update({
      trial: false
    })
  }

  // writeDates = () => {
  //   Object.entries(this.props.schools).map( school => {
  //     let schoolId = school[0]
  //     school = school[1]
  //     let schools = ['ISF Academy', 'Raha International School', 'Edubridge International School', 'Ajman Academy', 'Sekolah Victory Plus']
  //     if (schools.includes(school.name) && school.classes) {
  //       Object.entries(school.classes).map( clss => {
  //         this.props.firebase.database().ref(`/schools/${schoolId}/classes/${clss[0]}`).update({
  //           createdAt: 1567274122000
  //         })
  //       })
  //     }
  //   })
  // }

  render() {
    //Map schools data to table
    let data = []

    if (this.props.schools) {
      let schools = Object.entries(this.props.schools)
      //Filters
      if (this.state.schoolType != 'All') {
        schools = schools.filter(school =>
          school[1].type.includes(this.state.schoolType)
        )
      }
      if (this.state.schoolRegion != 'All') {
        schools = schools.filter(school =>
          school[1].region == this.state.schoolRegion
        )
      }
      if (this.state.schoolCountry != 'All') {
        schools = schools.filter(school =>
          school[1].country == this.state.schoolCountry
        )
      }

      const timeThen = moment().subtract(37, 'days').valueOf()
      const isExpired = timeThen > 1550747598664
      schools.map((school, i) => {

        if (school[1].active) {
          let program;
          let type;

          if (school[1].program.length > 1) {
            program = school[1].program.join(' & ')
          } else {
            program = school[1].program
          }

          if (school[1].type.length > 1) {
            type = school[1].type.join(' & ')
          } else {
            type = school[1].type
          }

          let trial;
          if (school[1].trial) {
            const createdAt = moment(school[1].createdAt)
            const timeLeft = moment().diff(createdAt, 'days')
            const daysLeft = 37 - timeLeft
            trial =
              <div>
                <p style={{margin: 0, textAlign: 'center'}}>{`${daysLeft} Days left`}</p>
                <Popconfirm placement="top" title={'Sure?'} onConfirm={() => this.cancelExpiry(school[0])} okText={"Yes"} cancelText={"No"}>
                  <Button  style={{marginBottom: 5}} type="danger">Cancel expiry</Button>
                </Popconfirm>
              </div>
          } else {
            trial = '-'
          }
          //console.log('products', products)

          data.push(
            {
              id: school[0],
              key: i,
              //      group: school[1].group,
              type: type,
              program: program,
              name: school[1].name,
              region: school[1].region,
              country: school[1].country,
              description: school[1].description,
              address: school[1].address,
              phone: school[1].phone,
              email: school[1].email,
              history: school[1].history,
              products: school[1].products || ['SkillTracker'],
              academicYear: school[1].academicYear,
              state: <Switch
                checked={pathOr(true,['activated'], school[1])}
                onChange={(checked) => this.setSchoolState(checked, school[0])}
                loading={this.state.loadingSwitch === school[0]}
                 />,
              edit: <Icon style={{ fontSize: '24px' }} type="edit" />,
              trial: trial,
              // delete:       <Popconfirm placement="top" title={'Are you sure you want to remove this school?'} onConfirm={() => this.removeEntry('remove')} okText={t("Yes")} cancelText={t("No")}>
              //                 <Icon style={{fontSize: '24px'}} type="delete" />
              //               </Popconfirm>,
              archive: <Popconfirm placement="top" title={'Are you sure you want to archive this school? The connected data will remain stored.'} onConfirm={() => this.removeEntry('archive')} okText={"Yes"} cancelText={"No"}>
                <Button type="danger">Archive</Button>
              </Popconfirm>
            }
          )
        }
      })

    }

    const columns = [
      // {
      //   title: 'Group',
      //   dataIndex: 'group',
      //   key: 'group',
      //   sorter: true,
      // },
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        sorter: true
      },
      {
        title: 'Program',
        dataIndex: 'program',
        key: 'program',
        sorter: true
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true
      },
      {
        title: 'Region',
        dataIndex: 'region',
        key: 'region',
        sorter: true
      },
      {
        title: 'Country',
        dataIndex: 'country',
        key: 'country',
        sorter: true
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        sorter: true
      },
      {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
        sorter: true,
        width: '70'
      },
      {
        title: 'Contact phone number',
        dataIndex: 'phone',
        key: 'phone',
        sorter: true
      },
      {
        title: 'Contact email address',
        dataIndex: 'email',
        key: 'email',
        sorter: true
      },
      {
        title: 'Products',
        dataIndex: 'products',
        key: 'products',
        width: '50',
        render: (record) => {
          return record && record.join(', ')
        }
      },
      {
        title: 'Active',
        dataIndex: 'state',
        key: 'state',
        width: '50'
      },
      {
        title: 'Trial',
        dataIndex: 'trial',
        key: 'trial',
      },
      {
        title: '',
        dataIndex: 'edit',
        key: 'edit',
        width: '50',
        onCell: (record) => {
          return {
            onClick: () => { this.openModal('edit', record) }
          };
        }
      },
      {
        title: '',
        dataIndex: 'archive',
        key: 'archive',
        width: '50',
        onCell: (record) => {
          return {
            onClick: () => { this.setState({ toRemove: record.id }) }
          };
        }
      }

    ]
    const { t } = this.props;
    return (
      <div>
        <div style={styles.container}>
          <div style={styles.submenu}>
            <Dropdown overlay={this.schoolTypes()}>
              <Button style={styles.dropdown}>
                {this.state.schoolType == 'All' ? 'School Type' : this.state.schoolType} <Icon type="down" />
              </Button>
            </Dropdown>
            <Dropdown overlay={this.schoolRegions()}>
              <Button style={styles.dropdown}>
                {this.state.schoolRegion == 'All' ? 'School Region' : this.state.schoolRegion} <Icon type="down" />
              </Button>
            </Dropdown>
            <Dropdown disabled={this.state.schoolRegion == 'All'} overlay={this.schoolCountries()}>
              <Button style={styles.dropdown}>
                {this.state.schoolCountry == 'All' ? 'School Country' : this.state.schoolCountry} <Icon type="down" />
              </Button>
            </Dropdown>
            <Icon style={styles.logout} type="unlock" onClick={() => this.props.firebase.logout()} />
            <Button
              onClick={() => this.openModal('add')}
              style={styles.buttonBlue} type="primary"
            >
              <Icon type="user-add" />{t('Add School')}
            </Button>
          </div>
          <div style={styles.inner}>
            <Table
              id='log-table'
              columns={columns}
              scroll={{ x: 1500 }}
              dataSource={data}
            />
          </div>
        </div>
        <ModalSchools
          mode={this.state.modalMode}
          ref={instance => { this.modal = instance; }}
          data={this.state.modalData}
          open={this.state.modalOpen}
          save={(data, mode) => this.saveModal(data, mode)}
          cancel={this.cancelModal}
          t={this.props.t}
        />
      </div>
    )
  }
}

const enhancer = compose(
  translate('lang'),
  firebaseConnect((props) => {
    return [
      'schools', 'users'
    ]
  }),
  connect(
    state => ({
      schools: state.firebase.data.schools,
      users: state.firebase.data.users
    })
  )
)
export default enhancer(STAdminSchools);

const styles = {

  container: {
    padding: '20px'
  },

  logout: {
    fontSize: '30px',
    float: 'right',
    marginLeft: '10px',
    cursor: 'pointer'
  },

  buttonBlue: {
    float: 'right',
    fontSize: '17px',
    backgroundColor: '#4A90E2',
    border: 'none',
    fontSize: '14px',
    borderRadius: '15px'
  },

  submenu: {
    marginBottom: '20px',
    overflow: 'hidden'
  },

  inner: {
    padding: 20,
    backgroundColor: 'white',
    boxShadow: '0 1px 3px 1px rgba(119,151,178,0.16)'
  },

  dropdown: {
    width: 180,
    borderRadius: 25,
    marginRight: 10
  }
}



// WEBPACK FOOTER //
// ./src/containers/STAdminSchools/index.jsx